import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription, switchMap } from 'rxjs';
import { SharedService } from '../../../services/shared.service';
import { SelectionService } from '../../../services/select.service';
import { QueryService } from '../../../services/query.service';
import * as ExcelJS from 'exceljs';
@Component({
  selector: 'app-formula-timekeeping',
  standalone: false,
  templateUrl: './formula-timekeeping.component.html',
  styleUrl: './formula-timekeeping.component.css'
})
export class FormulaTimekeepingComponent {
  @ViewChild('employee') employee!: ElementRef;
  searchKeyword$ = new Subject<string>();
  searchSub!: Subscription;
  window: Window = window;
  selectedRoles: any;
  constants: any = {};
  shareObject: any = {
    daysArray: [],
    selectedRows: new Set(),
    checkList: [],

    component: '/formula_timekeeping',
    addURL: '/user/employee/formula/timekeeping/create',
    editURL: '/user/employee/formula/timekeeping/edit',
    listURL: '/user/employee/formula/timekeeping/list',
    deletedURL: '/user/employee/formula/timekeeping/deleted',
    tableURL: '/user/employee/timekeeping',
  };
  formHandle!: FormGroup;
  filterForm!: FormGroup
  constructor(
    public sharedService: SharedService,
    public selectionService: SelectionService,
    private queryService: QueryService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = { filter: this.sharedService.shareObject.filter.user };
    this.shareObject.active = 'day';
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
      }
      // if (params['timesheet']) {
      //   this.shareObject.filterTimesheet = params['timesheet'];
      //   this.shareObject.options.filter.timesheet = { $elemMatch: { $eq: params['timesheet'] } };
      // }
    })
  }
  ngOnInit(): void {
    // 1: tính lương theo giờ, 2: tính lương theo ngày, 3: KPI, 4: không cần chấm công,5: tính lương theo tháng, 6: tính lương theo giờ + kpi, 7: tính lương theo ngày + kpi, 8: tính lương theo tháng + kpi
    this.shareObject.timekeepingTypes = this.sharedService.env.timekeepingTypes;
    this.constants = this.sharedService.env.constants;
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.shareObject.active = 'day';
    this.shareObject.formFields = [
      {
        field: 'employee', default: '', valid: [Validators.required],
        filter: (value: any) => {
          if (/^\d+$/.test(value)) {
            return { 'profile.employeeId': parseInt(value) };
          }
          return { 'profile.name': { $regex: value, $options: 'i' } };

        }
      },
      { field: 'type', default: '', valid: [Validators.required] },
      { field: 'workhours', default: 8, valid: [Validators.required, Validators.min(1)] },
      { field: 'overtimeRate', default: 1 },
      { field: 'standard', default: 0 },
      { field: 'status', default: 1 },
      { field: 'limit', default: this.sharedService.env.pageSize[0] },
      {
        field: 'timekeeping', default: '',
        filter: (value: any) => {
          return { type: parseInt(value) };
        },
        getValue: (v: any, s: any) => {
          let name = s.timekeepingTypes.find((e: any) => e.value === parseInt(v))?.name || '';
          return this.translate.instant(name);
        }
      },
      {
        field: 'employeeGroup', default: '',
        filter: (value: any) => {
          return { employeeGroup: value }
        },
        getValue: (v: any, s: any) => {
          return s.employeeGroups.find((e: any) => e.id === v)?.name || '';
        }
      },
      {
        field: 'start', default: '',
        filter: (value: any) => {
          return { start: value }
        },
      },
      {
        field: 'end', default: '',
        filter: (value: any) => {
          return { end: value }
        },
      },
      {
        field: 'limit', default: this.sharedService.env.pageSize[0],
        filter: (value: any) => {
          return { limit: value }
        },
      }
    ]
    let defineForm = this.sharedService.defineForm(this.shareObject.formFields);
    this.shareObject.filter = defineForm.filter;
    this.formHandle = this.fb.group(defineForm.formHandle);
    this.shareObject.filterForm = this.fb.group(defineForm.filterForm);
    if (this.shareObject.data.type == 'edit' || this.shareObject.data.type == 'add') {
      this.shareObject.userName = this.translate.instant('select_user');
    }
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params['type']) {
        this.shareObject.active = params['type'];
        this.checkType();
      } else {
        this.checkType();
      }
      if (params['employeeId']) {
        this.shareObject.filterForm.patchValue({ employee: params['employeeId'] });
        this.shareObject.options.filter['profile.employeeId'] = params['employeeId'];
      }
    })
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`${this.shareObject.component}/get_by_user`, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false;
        this.shareObject.employeeGroups = res.employeeGroups;
        this.shareObject.pagination = res.data.pagination;

        let maxIdLength = Math.max(...res.data.data.map((e: any) => String(e.profile?.employeeId).length || 0));
        this.shareObject.users = res.data.data.map((item: any) => {
          item.profile.employeeId = String(item.profile.employeeId).padStart(maxIdLength, '0');
          if (item.timekeeping) {
            item.timekeeping.typeText = this.sharedService.timekeepingTypeText(item.timekeeping.type);
          }
          return item;
        })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false;
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })


  }
  getBatchData() {
    this.shareObject.payload = {
      timekeeping: this.queryService._timekeepings,
      group: this.queryService._groups,
      users: this.queryService._users,
    };
    this.shareObject.filters = this.sharedService.createFilters(this.shareObject).filters;
    if (this.shareObject.filters && this.shareObject.filters.length > 0) {
      this.shareObject.filters.forEach((item: any) => {
        if (item.key == 'timekeeping') {
          this.shareObject.payload.timekeeping.data.filter = item.filter;
          this.shareObject.payload.users.data.filter._id = { $in: "timekeeping.data.$employee" };
        }
        if (item.key == 'employeeGroup') {
          this.shareObject.payload.users.data.filter['profile.employeeGroup'] = item.value;
        }
        if (item.key == 'employee') {
          this.shareObject.payload.users.data.filter = {
            ...this.shareObject.payload.users.data.filter,
            ...item.filter
          }
        }
        this.shareObject.payload.users.data.limit = item.key == 'limit' ? item.value : this.sharedService.env.pageSize[0];
        this.shareObject.options.limit = item.key == 'limit' ? item.value : this.sharedService.env.pageSize[0];
      });
    }
    this.shareObject.payload.users.data.page = this.shareObject.options.page || 1;
    this.sharedService.getBatch(this.shareObject).subscribe((res: any) => {
      this.shareObject.users = res.responses.users?.data?.data || [];
      this.shareObject.pagination = res.responses.users?.data?.pagination || {};
      this.shareObject.employeeGroups = res.responses.group?.data || [];
      this.shareObject.timekeepings = res.responses.timekeeping?.data || [];
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        e.timekeeping = this.shareObject.timekeepings.find((t: any) => t.employee === e.id) || null;
        if (e.timekeeping) {
          e.timekeeping.typeText = this.sharedService.timekeepingTypeText(e.timekeeping.type);
        }
        return e;
      });
      //sort user có timekeeping trước
      this.shareObject.users.sort((a: any, b: any) => {
        if (a.timekeeping && !b.timekeeping) return -1;
        if (!a.timekeeping && b.timekeeping) return 1;
        return 0;
      });
      this.shareObject.usersBak = [...this.shareObject.users];
    })
  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.getItem(this.shareObject).subscribe((res: any) => {
      this.formHandle.patchValue({
        employee: res.data.employee.id,
        type: res.data.type.toString(),
        overtimeRate: res.data.overtimeRate,
        workhours: res.data.workhours,
        status: res.data.status,
        standard: res.data.standard,
      });
      this.shareObject.userName = res.data?.employee?.profile?.name;
      this.shareObject.email = res.data?.employee?.email;
    })
  }
  getItemValue(user: any) {
    this.shareObject.employeeChecked = user;
    console.log('user checked', user);
    if (user.timekeeping) {
      this.shareObject.id = user.timekeeping.id;
      this.formHandle.patchValue({
        employee: user.id,
        type: user.timekeeping.type.toString(),
        overtimeRate: user.timekeeping.overtimeRate,
        workhours: user.timekeeping.workhours,
        status: user.timekeeping.status,
        standard: user.timekeeping.standard,
      });
    }
    this.formHandle.patchValue({
      employee: user.id,
    });
    this.sharedService.modalControl('#add-timekeeping');
  }
  getTableDay() {
    this.sharedService.callApi(`${this.shareObject.component}/table_timekeeping_day`, this.shareObject.options).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.dateKey = {
          month: res.dateKey.split('/')[0],
          year: res.dateKey.split('/')[1]
        };
        if (res.data.data.length > 0) {
          this.shareObject.daysArray = Object.keys(res.data.data[0].timekeepings).map((e: any) => {
            return {
              num: e,
              text: String(e).padStart(2, '0'),
              date: `${this.shareObject.dateKey.year}-${this.shareObject.dateKey.month}-${String(e).padStart(2, '0')}`
            };
          })
        }
        this.shareObject.timekeepingData = res.data.data || [];
        this.shareObject.pagination = res.data.pagination || {};
        this.shareObject.isLoading = false;
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger',
        });
        this.shareObject.isLoading = false;
      }
    })
  }
  getTableHour() {
    this.sharedService.callApi(`${this.shareObject.component}/table_timekeeping_hour`, this.shareObject.options).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.dateKey = {
          month: res.dateKey.split('/')[0],
          year: res.dateKey.split('/')[1]
        };
        this.shareObject.daysArray = Object.keys(res.data.data[0].timekeepings).map((e: any) => {
          return {
            num: e,
            text: String(e).padStart(2, '0'),
            date: `${this.shareObject.dateKey.year}-${this.shareObject.dateKey.month}-${String(e).padStart(2, '0')}`
          };
        })
        this.shareObject.timekeepingData = res.data.data;
        this.shareObject.pagination = res.data.pagination;
        this.shareObject.isLoading = false;
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('toast_cant_get_data'),
          type: 'danger',
        });
        this.shareObject.isLoading = false;
      }
    })
  }
  getTableKpi() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    this.sharedService.callApi(`${this.shareObject.component}/table_timekeeping_kpi`, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false;
        this.shareObject.items = res.data.data;
        this.shareObject.dateKey = {
          month: res.dateKey.split('/')[0],
          year: res.dateKey.split('/')[1]
        };
        this.shareObject.employeeGroups = res.employeeGroups;
        this.shareObject.daysArray = Object.keys(res.data.data[0].kpis).map((e: any) => {
          return { num: parseInt(e), text: String(e).padStart(2, '0') };
        })
        console.log(this.shareObject.daysArray);
        res.data.data.forEach((e: any) => {
          this.shareObject?.kpis?.push({ name: e.profile.name, employee: e.id, amount: 0, unit: '' });
          // this.shareObject.kpis.push({ name: e.profile.name, employee: e.id, amount: 0, unit: '' });
        })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false;
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
    })
  }
  addItem() {
    let payload = {
      employee: this.formHandle.value.employee,
      type: this.formHandle.value.type,
      overtimeRate: this.formHandle.value.overtimeRate,
      workhours: this.formHandle.value.workhours,
      standard: this.formHandle.value.standard,
      status: this.formHandle.value.status,
    }
    if (payload.type == '3') {
      delete payload.workhours;
      delete payload.standard;
    }
    if (payload.type != '2') {
      delete payload.standard;
    }
    this.shareObject.payload = payload;
    this.sharedService.addItem(this.shareObject).subscribe((res: any) => {
      this.sharedService.modalControl('#add-timekeeping', false);
      delete this.shareObject.employeeChecked;
      delete this.shareObject.id;
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        if (e.id === res.data.employee) {
          e.timekeeping = {
            id: res.data.id,
            type: res.data.type,
            overtimeRate: res.data.overtimeRate,
            workhours: res.data.workhours,
            standard: res.data.standard,
            status: res.data.status,
            user: res.data.user,
          }
          if (e.timekeeping) {
            e.timekeeping.typeText = this.sharedService.timekeepingTypeText(e.timekeeping.type);
          }
        }
        return e;
      });
      this.formHandle.reset();
    })
  }
  updateItem() {
    // this.shareObject.isLoading = true;
    this.shareObject.payload = {
      employee: this.formHandle.value.employee,
      type: this.formHandle.value.type,
      overtimeRate: this.formHandle.value.overtimeRate,
      workhours: this.formHandle.value.workhours,
      status: this.formHandle.value.status,
      standard: this.formHandle.value.standard,
    }
    this.sharedService.updateItem(this.shareObject).subscribe((res: any) => {
      this.sharedService.modalControl('#add-timekeeping', false);
      delete this.shareObject.employeeChecked;
      delete this.shareObject.id;
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        if (e.id === res.data.employee) {
          e.timekeeping = {
            id: res.data.id,
            type: res.data.type,
            overtimeRate: res.data.overtimeRate,
            workhours: res.data.workhours,
            standard: res.data.standard,
            status: res.data.status,
            user: res.data.user,
          }
          if (e.timekeeping) {
            e.timekeeping.typeText = this.sharedService.timekeepingTypeText(e.timekeeping.type);
          }
        }
        return e;
      });
      this.formHandle.reset();
    })
  }
  onSubmit() {
    if (this.formHandle.invalid) {
      console.log('form invalid', this.formHandle.value);
      this.sharedService.toast({
        title: this.translate.instant('title_form_invalid'),
        message: this.translate.instant('message_form_invalid'),
        type: 'danger',
      });
      return;
    }
    if (this.shareObject.id) {
      console.log('update item');
      this.updateItem();
    }
    else {
      this.addItem()
    }
  }
  deleteItem(ids: any) {
    let key = 'timekeeping';
    this.shareObject.ids = this.selectionService.handleIndextoId(ids, this.shareObject.users, key).map((e: any) => e.id);
    this.sharedService.deleteItem(this.shareObject).subscribe((res: any) => {
      this.shareObject.users = this.shareObject.users.map((e: any) => {
        if (this.shareObject.ids.includes(e[key].id)) {
          delete e[key];
        }
        return e;
      })
      this.selectionService.clearSelection();
    })
  }
  checkType() {
    this.getBatchData();
    if (this.shareObject.active == 'day' && this.shareObject.data.type == 'table') {
      this.getTableDay();
    } else if (this.shareObject.active == 'hour' && this.shareObject.data.type == 'table') {
      this.getTableHour();
    } else if (this.shareObject.active == 'kpi' && this.shareObject.data.type == 'table') {
      this.getTableKpi();
    }
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.checkType();
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.shareObject.filters = [];
    this.shareObject.filterForm.reset();
    let keys = Object.keys(this.shareObject.formFields).filter((key: any) => this.shareObject.formFields[key].filter);
    keys.forEach((key: any) => {
      this.shareObject.options.filter[key] = this.shareObject.formFields[key].default || '';
    });
    this.selectionService.clearSelection();
    this.checkType();
  }
  filterClear(item: any) {
    this.shareObject.filters = this.shareObject.filters.filter((f: any) => f.key !== item.key && f.value !== item.value);
    const [k, v] = Object.entries(item.filter)[0] || [];
    delete this.shareObject.options.filter[k];
    this.shareObject.filterForm.patchValue({ [item.key]: null });
    this.onSearch();
  }
  onSearch() {
    this.shareObject.filters = this.sharedService.createFilters(this.shareObject).filters;
    if (this.shareObject.filters && this.shareObject.filters.length > 0) {
      this.shareObject.filters.forEach((item: any) => {
        this.shareObject.options.filter = { ...this.shareObject.options.filter, ...item.filter };
      });
    }
    this.checkType();
  }
  filter(key: any, value: any) {
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      delete this.shareObject[key];
    } else {
      this.shareObject[key] = value;
    }
    this.onSearch();
  }
  onSearchBak() {
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ? this.filterForm.value['keyword'].trim() : undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.limit = this.filterForm.value['limit'] ? this.filterForm.value['limit'] : this.sharedService.env.pageSize[0];
    let group = this.filterForm.value['profile.employeeGroup'] ?? undefined;
    if (group) {
      this.shareObject.options.filterUser['profile.employeeGroup'] = group;
      this.shareObject.groupName = this.shareObject.employeeGroups.find((e: any) => e.id == group)?.name;
    }
    this.checkType();
  }
  onSearch_() {
    const form = this.filterForm.value;
    const filters: ((item: any) => boolean)[] = [];
    this.shareObject.keyword = form.keyword?.trim().toLowerCase() || undefined;
    this.shareObject.timekeeping = form.timekeeping || undefined;
    this.shareObject.employeeGroup = form.employeeGroup || undefined;
    // Keyword filter
    if (this.shareObject.keyword) {
      const isNumber = /^\d+$/.test(this.shareObject.keyword);
      filters.push(isNumber
        ? (item: any) => item.profile.employeeId == this.shareObject.keyword
        : (item: any) =>
          item.profile.name.toLowerCase().includes(this.shareObject.keyword) ||
          item.email.toLowerCase().includes(this.shareObject.keyword)
      );
    }
    if (this.shareObject.employeeGroup) {
      filters.push((item: any) =>
        item.profile.employeeGroup && item.profile.employeeGroup.id == this.shareObject.employeeGroup
      );
      this.shareObject.groupName = this.shareObject.employeeGroups.find(
        (e: any) => e.id == this.shareObject.employeeGroup
      )?.name;
    }
    if (this.shareObject.timekeeping) {
      filters.push((item: any) =>
        item.timekeeping && item.timekeeping.type == this.shareObject.timekeeping
      );
      this.shareObject.timekeepingName = this.sharedService.env.timekeepingTypes.find(
        (e: any) => e.value == this.shareObject.timekeeping
      )?.name;
    }
    this.shareObject.users = this.shareObject.usersBak.filter((item: any) =>
      filters.every(fn => fn(item))
    );
    this.shareObject.filterBox = false;
  }
  onRowClick(event: MouseEvent, index: number) {
    this.selectionService.selectRow(event, index);
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }
  private getExcelColumnName(num: number): string {
    return num <= 26
      ? String.fromCharCode(64 + num)
      : this.getExcelColumnName(Math.floor((num - 1) / 26)) + String.fromCharCode(65 + ((num - 1) % 26));
  }
  exportTimekeepingToExcel() {
    // Tạo workbook mới
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Timekeeping');

    const titleRow = worksheet.addRow([`Bảng Công tháng ${this.shareObject.dateKey.month}/${this.shareObject.dateKey.year}`]);
    titleRow.font = { bold: true, size: 16, color: { argb: 'FF000000' } };

    // Merge cells cho tiêu đề (từ cột A đến cột cuối cùng)
    const lastColumn = this.getExcelColumnName(this.shareObject.daysArray.length + 1);
    worksheet.mergeCells(`B1:${lastColumn}1`);
    //cố định cot A
    worksheet.views = [
      { state: 'frozen', xSplit: 1, ySplit: 2 }
    ];
    // Thêm dòng trống
    worksheet.addRow([]);
    // Tạo header row
    const headerRow = worksheet.addRow(['Nhân viên', ...this.shareObject.daysArray.map((day: any) => day.text), 'Total']);

    // Style cho header
    headerRow.eachCell((cell) => {
      cell.font = { bold: true }; // Chỉ để bold, không set màu
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Thêm dữ liệu
    this.shareObject.timekeepingData.forEach((employee: any) => {
      const rowData = [
        employee.profile?.name || ''
      ];

      // Thêm dữ liệu từng ngày
      this.shareObject.daysArray.forEach((day: any) => {
        console.log(employee.profile.name, day.date, employee.timekeepings?.[day.num]);
        const value = employee.timekeepings?.[day.num].toString() || "0";
        rowData.push(value);
      });

      // Thêm tổng
      rowData.push(employee.timekeepingTotal || 0);

      const row = worksheet.addRow(rowData);

      // Style cho dữ liệu
      row.eachCell((cell, colNumber) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        // Style cho cột total
        if (colNumber === rowData.length) {
          cell.font = { bold: true, color: { argb: 'FF0070C0' } };
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        } else if (colNumber > 1) { // Các cột ngày
          cell.alignment = { vertical: 'middle', horizontal: 'center' };

          // Highlight các cell có giá trị 'P'
          if (cell.value === 'P') {
            cell.font = { color: { argb: 'FFFFC000' } }; // Màu vàng tương ứng với text-warning
          }
        }
      });
    });

    // Auto fit columns
    worksheet.columns.forEach((column: any) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        const columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength + 2;
    });

    const fileName: string = 'timekeeping_report.xlsx'
    // Xuất file
    workbook.xlsx.writeBuffer().then((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }
  exportKpiToExcel() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('KPI Report');

    // Thêm tiêu đề
    const titleRow = worksheet.addRow([`Bảng KPI tháng ${this.shareObject.dateKey.month}`]);
    titleRow.font = { bold: true, size: 16 };

    const lastColumn = this.getExcelColumnName(this.shareObject.daysArray.length + 3); // +3 cho cột Nhân viên, Đơn vị, Total
    worksheet.mergeCells(`C1:${lastColumn}1`);
    worksheet.addRow([]);
    //cố định cột A và B
    worksheet.views = [
      { state: 'frozen', xSplit: 2, ySplit: 2 }
    ];
    // Header row
    const headerRow = worksheet.addRow([
      'Nhân viên',
      'Đơn vị',
      ...this.shareObject.daysArray.map((day: any) => day.text),
      'Total'
    ]);

    // Style header
    headerRow.eachCell((cell: any) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = this.getThinBorder();
    });

    // Data rows
    this.shareObject.items.forEach((employee: any) => {
      this.addEmployeeData(worksheet, employee, this.shareObject.daysArray);
    });

    // Auto fit columns
    this.autoFitColumns(worksheet);

    // Export
    const fileName: string = 'kpi_report.xlsx'
    const buffer = workbook.xlsx.writeBuffer();
    buffer.then((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    });
  }

  private addEmployeeData(worksheet: ExcelJS.Worksheet, employee: any, daysArray: any[]) {
    const maxUnits = Math.max(
      employee?.units?.length || 0,
      employee?.totalByUnit?.length || 0,
      ...daysArray.map(day => employee?.kpis[day.num]?.length || 0)
    );

    // Nếu không có dữ liệu con, thêm 1 dòng đơn giản
    if (maxUnits === 0) {
      const rowData = [
        employee.profile?.name || '',
        '', // Đơn vị trống
        ...daysArray.map(day => '0'), // Tất cả ngày là 0
        '0' // Total
      ];

      const row = worksheet.addRow(rowData);
      this.applyDataRowStyle(row, daysArray.length);
      return;
    }

    // Thêm dữ liệu cho mỗi unit
    for (let i = 0; i < maxUnits; i++) {
      const rowData = [];

      // Cột Nhân viên (chỉ hiển thị ở dòng đầu)
      if (i === 0) {
        rowData.push(employee.profile?.name || '');
      } else {
        rowData.push(''); // Các dòng sau để trống
      }

      // Cột Đơn vị
      const unit = employee?.units?.[i];
      rowData.push(unit?.name || '');

      // Các cột ngày
      daysArray.forEach(day => {
        const kpi = employee?.kpis[day.num]?.[i];
        rowData.push(kpi?.quantity?.toString() || '0');
      });

      // Cột Total
      const total = employee?.totalByUnit?.[i];
      rowData.push(total?.quantity?.toString() || '0');

      const row = worksheet.addRow(rowData);
      this.applyDataRowStyle(row, daysArray.length);
    }
  }

  private applyDataRowStyle(row: ExcelJS.Row, daysCount: number) {
    row.eachCell((cell: any, colNumber: any) => {
      cell.border = this.getThinBorder();

      // Căn phải cho các cột số
      if (colNumber >= 3 && colNumber <= daysCount + 2) { // Các cột ngày
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
      } else if (colNumber === daysCount + 3) { // Cột Total
        cell.alignment = { vertical: 'middle', horizontal: 'right' };
        cell.font = { bold: true };
      } else if (colNumber === 2) { // Cột Đơn vị
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
      } else if (colNumber === 1) { // Cột Nhân viên
        cell.alignment = { vertical: 'middle', horizontal: 'left' };
      }
    });
  }

  // private getExcelColumnName(num: number): string {
  //   let columnName = '';
  //   let temp = num;
  //   while (temp > 0) {
  //     const modulo = (temp - 1) % 26;
  //     columnName = String.fromCharCode(65 + modulo) + columnName;
  //     temp = Math.floor((temp - modulo) / 26);
  //   }

  //   return columnName;
  // }

  private getThinBorder() {
    return {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  }

  private autoFitColumns(worksheet: ExcelJS.Worksheet) {
    worksheet.columns.forEach((column: any) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell: any) => {
        const length = cell.value ? cell.value.toString().length : 10;
        if (length > maxLength) maxLength = length;
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 50);
    });
  }
}


